export const NEW_IN_TODAY_WOMEN_CATEGORY_ID = "51163";
export const NEW_IN_TODAY_MEN_CATEGORY_ID = "51164";
export const SEARCH_RESULTS_LIMIT = 1;
